import { createSelector } from 'reselect';
import _intersection from 'lodash/intersection';
import _keys from 'lodash/keys';
import _concat from 'lodash/concat';

const activeFacets = state => state.activeFacetElements;
const facetMatches = state => state.facetMatches;
const peopleByDistinction = state => state.guestsByGuestDistinction;

const peopleSet = createSelector(
  peopleByDistinction,
  (people) => {
    const guests = _keys(people.guests);
    const couple = _keys(people.couple);
    return _concat(guests, couple);
  }
);

const getActiveMatches = createSelector(
  activeFacets,
  facetMatches,
  peopleSet,
  (activeFacetsElements, facetElementMatches, people) => {
    if (activeFacetsElements.length === 0) return people;
    if (activeFacetsElements.length === 1) return facetElementMatches[activeFacetsElements[0]];
    const mappedMatches = activeFacetsElements.map(key => facetElementMatches[key]);
    const matches = _intersection(people, ...mappedMatches);
    return matches;
  }
);

export default getActiveMatches;



// WEBPACK FOOTER //
// ./src/selectors/seatingchart/guestRailSelector.js